import React from 'react'
import { useFormContext } from 'react-hook-form'
import { DSSpacer } from '@zoe/ds-web'
import { FieldError } from './FieldError'

export interface CheckboxGroupProps extends React.ComponentProps<'input'> {
  children: React.ReactNode
  name: string
  legend?: string
}

export const CheckboxGroup: React.FC<CheckboxGroupProps> = ({ ...props }) => {
  const { formState } = useFormContext()
  const children = React.Children.toArray(props.children)

  return (
    <fieldset
      id={props.name}
      className={props.className}
      data-testid={`${props.name}-checkbox-group`}
      style={{ border: 'none', padding: 0, margin: 0 }}
    >
      {children.map((child, index) => (
        <React.Fragment key={index}>
          {child}
          {index < children.length - 1 && <DSSpacer size={16} direction="vertical" />}
        </React.Fragment>
      ))}
      {formState.errors[props.name] && (
        <FieldError>{formState.errors[props.name]?.message as string | undefined}</FieldError>
      )}
    </fieldset>
  )
}
